import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DeleteOutlined } from '@ant-design/icons'
import { Modal, Tooltip } from 'antd'
import { selectCurrentUserCompanyId } from '@reducers/currentUser/currentUserSelectors'
import { updateCompany } from '@actions/currentUser'

import styles from './DeletePaymentMethodButton.module.scss'

const DeletePaymentMethodButton = (props) => {
  const { onDelete, paymentMethodId, disabled } = props
  const companyId = useSelector(selectCurrentUserCompanyId)
  const dispatch = useDispatch()
  const [isModalDPMVisible, setIsDPMVModalVisible] = useState(false)
  const [isDPMLoading, setIsDPMLoading] = useState(false)

  const confirmDelete = async () => {
    setIsDPMLoading(true)

    await dispatch(updateCompany(
      { delete_payment_method: paymentMethodId },
      companyId
    ))

    setIsDPMLoading(false)

    onDelete()
  }

  const showModal = () => {
    setIsDPMVModalVisible(true)
  }

  const hideModal = () => {
    setIsDPMVModalVisible(false)
  }

  if (disabled) {
    return (
      <Tooltip title="You cannot delete the only remaining payment method" placement="right">
        <DeleteOutlined className={'disabled'} role="button"/>
      </Tooltip>
    )
  } else {
    return (
      <React.Fragment>
        <DeleteOutlined
          className={styles.deletePaymentMethodButton}
          onClick={showModal}
          role="button"
        />
        <Modal
          visible={isModalDPMVisible}
          onOk={confirmDelete}
          onCancel={hideModal}
          confirmLoading={isDPMLoading}
        >
          <p>Are you sure delete this payment method?</p>
        </Modal>
      </React.Fragment>
    )
  }
}

DeletePaymentMethodButton.defaultProps = {
  onDelete: () => null,
}

export default DeletePaymentMethodButton
